module.exports = __webpack_public_path__ + "static/img/Mitch_McGovern_mobile.66590d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch_McGovern_mobile.jpg
// module id = u24b
// module chunks = 0